import { render, staticRenderFns } from "./SelectRule.vue?vue&type=template&id=77a5b4d5"
import script from "./SelectRule.vue?vue&type=script&lang=js"
export * from "./SelectRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports